import { render } from "./yx-tips.vue?vue&type=template&id=bdbf2c92&scoped=true"
import script from "./yx-tips.vue?vue&type=script&lang=js"
export * from "./yx-tips.vue?vue&type=script&lang=js"

import "./yx-tips.vue?vue&type=style&index=0&id=bdbf2c92&lang=scss&scoped=true"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdbf2c92"]])

export default __exports__